// extracted by mini-css-extract-plugin
export default {"wrap":"app_wrap__ivzMG"};